import {
  getMobilePreviewUrl,
  shouldUseMobilePreviewInBrowser,
} from "./mobile-preview/device";

if (shouldUseMobilePreviewInBrowser()) {
  window.location.replace(getMobilePreviewUrl(window.location.href));
} else {
  void import("./desktop-entry");
}
